import React from "react";

import imgfb from "../images/facebook.png";
import imginsta from "../images/instagram.png";
import imgyt from "../images/youtube.png";
import imgtele from "../images/telegram.png";
import imgpod from "../images/podcast.png";

import i18n from "i18next";

const Footer = ({}) => {
  return (
    <footer
      className="footer global-footer global-footer--member"
      // style={{ display: "block", position: "absolute" }}
    >
      <div className="aem-Grid aem-Grid--default--12 base-print-grid">
        <div
          className="aem-GridColumn aem-GridColumn--default--12"
          style={{ height: "auto" }}
        >
          <div className="global-footer--title">
            <h3
              className="text__title"
              style={{ fontSize: 32, color: "white", fontFamily: "Montserrat" }}
            >
              CPF Board{" "}
            </h3>
          </div>

          <div className="global-footer-navbar">
            <div className="global-footer-navbar--start-menu">
              <ul>
                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/employer/services-for-business-partners"
                    target="_self"
                    aria-label="Business partners"
                    data-analytics-click-id="GlobalFooterLinkSection2"
                    data-analytics-text="Business partners"
                  >
                    <span className="cmp-button__text">Business partners</span>
                  </a>
                </li>

                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/member/useful-links"
                    target="_self"
                    aria-label="Useful links"
                    data-analytics-click-id="GlobalFooterLinkSection2"
                    data-analytics-text="Useful links"
                  >
                    <span className="cmp-button__text">Useful links</span>
                  </a>
                </li>

                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/member/who-we-are/careers"
                    target="_self"
                    aria-label="Careers "
                    data-analytics-click-id="GlobalFooterLinkSection2"
                    data-analytics-text="Careers "
                  >
                    <span className="cmp-button__text">Careers </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="global-footer-navbar--end-menu">
              <ul className="footer-nav-link">
                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/service/contact-us"
                    target="_self"
                    aria-label="Contact us"
                    data-analytics-click-id="GlobalFooterLinkSection2"
                    data-analytics-text="Contact us"
                  >
                    <span className="cmp-button__text">Contact us</span>
                  </a>
                </li>

                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/writetous"
                    target="_self"
                    aria-label="Feedback"
                    data-analytics-click-id="GlobalFooterLinkSection2"
                    data-analytics-text="Feedback"
                  >
                    <span className="cmp-button__text">Feedback</span>
                  </a>
                </li>

                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/memberfaq"
                    target="_self"
                    aria-label="FAQ"
                    data-analytics-click-id="GlobalFooterLinkSection2"
                    data-analytics-text="FAQ"
                  >
                    <span className="cmp-button__text">FAQ</span>
                  </a>
                </li>
              </ul>
              <ul className="footer-social-icon">
                <li>
                  <a
                    className="global-footer-navbar-item remove-global-external-icon"
                    aria-label="Global footer social"
                    href="https://www.facebook.com/CPFBoard"
                    target="_blank"
                    data-analytics-click-id="GlobalFooterSocialFacebook"
                  >
                    <i className="icon-dls-facebook" aria-hidden="true"></i>
                  </a>
                </li>

                <li>
                  <a
                    className="global-footer-navbar-item remove-global-external-icon"
                    aria-label="Global footer social"
                    href="https://www.instagram.com/cpf_board/"
                    target="_blank"
                    data-analytics-click-id="GlobalFooterSocialInstagram"
                  >
                    <i className="icon-dls-instagram" aria-hidden="true"></i>
                  </a>
                </li>

                <li>
                  <a
                    className="global-footer-navbar-item remove-global-external-icon"
                    aria-label="Global footer social"
                    href="https://www.youtube.com/user/CPFvideos"
                    target="_blank"
                    data-analytics-click-id="GlobalFooterSocialYoutube"
                  >
                    <i className="icon-dls-youtube" aria-hidden="true"></i>
                  </a>
                </li>

                <li>
                  <a
                    className="global-footer-navbar-item remove-global-external-icon"
                    aria-label="Global footer social"
                    href="https://cpf.gov.sg/WhatsApp"
                    target="_blank"
                    data-analytics-click-id="GlobalFooterSocialWhatsapp"
                  >
                    <i className="icon-dls-whatsapp" aria-hidden="true"></i>
                  </a>
                </li>

                <li>
                  <a class="global-footer-navbar-item remove-global-external-icon" aria-label="Global footer social" href="https://sg.linkedin.com/company/cpf-board" target="_blank" data-analytics-click-id="GlobalFooterSocialLinkedin" rel="noopener">
                    <i class="icon-dls-linkedin" aria-hidden="true"></i>
                  </a>
                </li>
                
              </ul>
            </div>
          </div>
          <div className="separator ">
            <div className="cmp-separator">
              <hr
                className="cmp-separator__horizontal-rule cmp-separator--dotted"
                style={{ color: "white" }}
              />
            </div>
          </div>
          <div className="global-footer-compliance">
            <div className="global-footer-compliance--start-menu">
              <ul>

                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/member/sitemap"
                    target="_self"
                    aria-label="Sitemap"
                    data-analytics-click-id="GlobalFooterLinkSection3"
                    data-analytics-text="Sitemap"
                  >
                    <span className="cmp-button__text">Sitemap</span>
                  </a>
                </li>

                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="https://www.tech.gov.sg/report_vulnerability"
                    target="_blank"
                    aria-label="Report vulnerability"
                    data-analytics-click-id="GlobalFooterLinkSection3"
                    data-analytics-text="Report vulnerability"
                    style={{ alignItems: "center", height: 26 }}
                  >
                    <span className="cmp-button__text">
                      Report vulnerability
                    </span>
                    <span className="icon-dls-external-link"></span>
                  </a>
                </li>

                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/member/privacy-statement"
                    target="_self"
                    aria-label="Privacy statement"
                    data-analytics-click-id="GlobalFooterLinkSection3"
                    data-analytics-text="Privacy statement"
                  >
                    <span className="cmp-button__text">Privacy statement</span>
                  </a>
                </li>

                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/member/terms-of-use"
                    target="_self"
                    aria-label="Terms of use"
                    data-analytics-click-id="GlobalFooterLinkSection3"
                    data-analytics-text="Terms of use"
                  >
                    <span className="cmp-button__text">Terms of use</span>
                  </a>
                </li> 

                <li>
                  <a
                    className="cmp-button cmp-button--link cmp-button--inverse"
                    href="/member/security-best-practices"
                    target="_self"
                    aria-label="Security best practices"
                    data-analytics-click-id="GlobalFooterLinkSection3"
                    data-analytics-text="Security best practices"
                  >
                    <span className="cmp-button__text">
                      Security best practices
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="global-footer-compliance--end-menu">
              <ul>
                <li>© 2024, Government of Singapore</li>
                <li>Last updated 29 Aug 2024</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
